module.exports = __webpack_public_path__ + "img/sepa.2d75285d.svg";